import styled from '@emotion/styled';
import find from 'lodash/find';
import { Container, Box, Flex, Icon } from '@qga/roo-ui/components';
import { getBookingDetailsPageLink } from 'lib/links';
import { useScrollTopOnMount } from 'lib/hooks';
import { useDetailsBooking } from 'lib/hooks/useDetailsBooking';
import * as tracking from 'lib/gaTracking/cancelBookingPageEvents';
import { ContentHeading, Link } from 'components/Typography';
import { useCancellationQuote } from '../CancellationQuoteProvider';
import CancellationPageLayout from '../CancellationPageLayout';
import RefundSummary from '../RefundSummary';
import PropertyCharges from '../PropertyCharges';
import RefundMessage from './RefundMessage';
import CreditVoucherRefundMessage from './CreditVoucherRefundMessage';

const GrowContainer = styled(Container)`
  flex-grow: 1;
`;

const ConfirmedCancellation = () => {
  const { booking } = useDetailsBooking();
  const { cancellation } = useCancellationQuote();
  const detailsPageLink = getBookingDetailsPageLink(booking.id);
  useScrollTopOnMount();

  const creditNoteRefund = find(cancellation?.refund?.breakdown, { method: 'credit_note' });
  const Message = creditNoteRefund ? CreditVoucherRefundMessage : RefundMessage;

  return (
    <CancellationPageLayout>
      <GrowContainer mt={[4, 12]} mb={[7, 8]}>
        <Flex flexDirection="column" width={['100%', '66%']}>
          <ContentHeading mb={2} fontSize={['2xl', '3xl']}>
            <Icon name="checkCircle" color="ui.success" mb={1} size={36} /> Your booking has been cancelled
          </ContentHeading>
          <Box mb={8}>
            <Message propertyName={booking.reservation.property.name} email={booking.travelArranger.email} />
          </Box>
          <PropertyCharges penalty={cancellation?.refund?.penalty!} />
          <RefundSummary />
          <Link
            mb={6}
            to={detailsPageLink}
            onClick={tracking.returnToManageYourBookingLinkSelected}
            data-testid="return-to-manage-your-booking"
          >
            Return to manage your booking
          </Link>
        </Flex>
      </GrowContainer>
    </CancellationPageLayout>
  );
};

export default ConfirmedCancellation;
